import "./PageNotFound.css";
import { Card } from "@mantine/core";
import { Link } from "react-router";

export function PageNotFound() {
	return (
		<Card className="page-not-found" padding={0}>
			<p>Oeps! De pagina die je zoekt bestaat niet.</p>
			<Link className="return-to-home" to="/">
				Terug naar de startpagina
			</Link>
		</Card>
	);
}
